module.exports = __webpack_public_path__ + "img/Elven_Bow_01.6db910ba.png";